<template>
  <div style="padding: 0 10px">
    <el-table
      :data="logTableData"
      border
      class="table-height"
      :header-cell-style="{background:'#f2f2f2',color:'black'}"
      :height="height"
    >
      <el-table-column
        :label="$t('GlobalSetObj.serial')"
        align="center"
        type="index"
        width="80"
        fixed="left"
      />
      <!-- 操作类型 -->
      <el-table-column
        prop="operationType"
        :label="$t('collectionCenter.operationType')"
        min-width="160"
        align="center"
      >
        <template #default="scope">
          <!--'已授权'-->
          <el-tag v-if="scope.row.operationType === 1" type="success">{{ $t('mdfeTranslate.Authorized') }}</el-tag>
          <!--已取消-->
          <el-tag v-else-if="scope.row.operationType === 2" type="info">{{ $t('GlobalSetObj.Canceled') }}</el-tag>
          <!--已关闭-->
          <el-tag v-else-if="scope.row.operationType === 3" type="danger">{{ $t('mdfeTranslate.Closed') }}</el-tag>
        </template>
      </el-table-column>
      <!-- 状态 -->
      <el-table-column
        prop="status"
        :label="$t('GlobalSetObj.status')"
        min-width="120"
        align="center"
      >
        <template #default="scope">
          <!--成功-->
          <el-tag v-if="scope.row.status === 1" type="success">{{ $t('GlobalSetObj.succeed') }}</el-tag>
          <!--失败-->
          <el-tag v-else-if="scope.row.status === 2" type="danger">{{ $t('GlobalSetObj.Lose') }}</el-tag>
        </template>
      </el-table-column>
      <!-- 车牌号 -->
      <el-table-column
        prop="vehiclePlate"
        :label="$t('seller.licensePlateNumber')"
        min-width="120"
        align="center"
      >
        <template #default="scope">
          <div v-for="(item, index) in scope.row.transportInfo.vehiclePlate" :key="index">{{ item }}</div>
        </template>
      </el-table-column>
      <!-- 操作人 -->
      <el-table-column prop="createUserStr" :label="$t('GlobalSetObj.operator')" min-width="180" />
      <!-- 操作时间 -->
      <el-table-column prop="updateTime" :label="$t('GlobalSetObj.operationTime')" min-width="180" />
      <!-- 备注 -->
      <el-table-column prop="remark" :label="$t('collectionCenter.Note')" min-width="180" />
    </el-table>

    <!-- 分页工具 -->
    <div class="pagination">
      <el-pagination
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="queryForm.pageNumber"
        :page-sizes="[10, 20, 50, 100]"
        :page-size.sync="queryForm.pageSize"
        :total="total"
        background
        style="margin: 10px 0"
        @current-change="getCurrentTable"
        @size-change="getSizeTable"
      />
    </div>
  </div>
</template>
<script>
import { getUserIdAndNameObj } from '@/enums/storageEnum';
import { getMdfeOperationLog } from '@/api/invoiceCenter';
const dayjs = require('dayjs');
export default {
  name: 'OperationalLog',
  props: {
    logKey: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      logTableData: [],
      queryForm: {
        pageSize: 10,
        pageNumber: 1,
        params: {
          mdfeKey: this.logKey.mdfeKey,
          createStartTime: this.logKey.createTime,
          createEndTime: dayjs(this.logKey.createTime).add(30, 'day').startOf('day').format('YYYY-MM-DD HH:mm:ss')
        }
      },
      total: 0,
      height: 300
    };
  },
  created() {
    this.height = document.body.clientHeight - 140;
    this.userObj = getUserIdAndNameObj();
    this.getTable();
  },
  methods: {
    // 获取列表
    getTable() {
      getMdfeOperationLog(this.queryForm).then(res => {
        res.data.records.map(item => {
          if (item.transportInfo) {
            item.transportInfo = JSON.parse(item.transportInfo);
          }
          if (item.updateUser) {
            item.createUserStr = this.userObj[item.updateUser] || '';
          }
        });
        this.logTableData = res.data.records;
        this.total = res.data.total;
      });
    },
    // 翻页
    getCurrentTable(val) {
      this.queryForm.pageNumber = val;
      this.getTable();
    },
    // 改变每页显示数量
    getSizeTable(val) {
      this.queryForm.pageSize = val;
      this.queryForm.pageNumber = 1;
      this.getTable();
    }
  }
};
</script>
<style scoped>

</style>
